// Known lat/lng for the free-shipping comuni shown on the checkout map
// (Admin > Aspetto > Zone spedizione). A comune added later purely via the
// admin-editable "comuni_names" field (no code change) still gets free
// shipping and shows up in all texts — it just won't have a pin here until
// someone adds its coordinates below.
export const COMUNE_COORDS = {
  "Siracusa": [37.0755, 15.2866],
  "Catania": [37.5079, 15.0830],
  "Adrano": [37.6667, 14.8333],
  "Belpasso": [37.5967, 14.9833],
  "Biancavilla": [37.6333, 14.8667],
  "Licodia Eubea": [37.1667, 14.7167],
  "Paternò": [37.5667, 14.9000],
};
